(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["halloween-nails"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('nail-book')) {
    customElements.define('nail-book', class extends HTMLElement {
      connectedCallback() {
        if(this.initialized) return;
        this.initialized=true;
        this.form=this.querySelector('.nb-form');this.add=this.querySelector('.nb-add');this.selection=this.querySelector('.nb-selection');this.error=this.querySelector('.nb-error');this.dialog=this.querySelector('dialog');this.viewer=this.querySelector('.nb-main-image');this.caption=this.querySelector('.nb-caption');this.busy=false;
        this.form.addEventListener('change',event=>{const input=event.target;if(input.matches('input[name="design"]')){this.viewer.src=input.dataset.image;this.viewer.removeAttribute('srcset');this.viewer.alt=input.dataset.title;this.caption.textContent=input.dataset.title;}this.update();});
        this.querySelector('.nb-enlarge').addEventListener('click',()=>{this.dialog.querySelector('img').src=this.viewer.currentSrc||this.viewer.src;this.dialog.querySelector('img').alt=this.viewer.alt;this.dialog.querySelector('p').textContent=this.caption.textContent;this.dialog.showModal();});
        this.querySelector('.nb-close').addEventListener('click',()=>this.dialog.close());
        this.dialog.addEventListener('click',event=>{if(event.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)this.dialog.close();}});
        this.form.addEventListener('submit',event=>this.submit(event));
        this.syncCart();
      }
      selected(){return [...this.querySelectorAll('input[name="design"]:checked:not(:disabled)')];}
      update(){const count=this.selected().length;this.selection.textContent=this.dataset.selectedLabel.replace('[count]',String(count));this.add.disabled=count===0||this.busy;}
      async syncCart(){try{const response=await fetch(this.dataset.cartUrl+'.js',{headers:{Accept:'application/json'}});if(!response.ok)return;const cart=await response.json();const ids=new Set(cart.items.map(item=>String(item.variant_id)));this.querySelectorAll('[data-variant-id]').forEach(card=>{if(ids.has(card.dataset.variantId)){const input=card.querySelector('input');input.checked=false;input.disabled=true;card.querySelector('.nb-stock').textContent=this.dataset.cartLabel;}});this.update();}catch(error){this.update();}}
      async submit(event){event.preventDefault();if(this.busy)return;const items=this.selected().map(input=>({id:input.value,quantity:1}));if(!items.length)return;this.busy=true;this.update();this.error.textContent='';try{const response=await fetch(this.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});const data=await response.json();if(!response.ok)throw new Error(data.description||data.message||this.dataset.errorLabel);window.location.assign(this.dataset.cartUrl);}catch(error){this.error.textContent=error.message||this.dataset.errorLabel;this.busy=false;await this.syncCart();this.update();}}
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nail-book-s"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('nail-book')) {
    customElements.define('nail-book', class extends HTMLElement {
      connectedCallback() {
        if(this.initialized) return;
        this.initialized=true;
        this.form=this.querySelector('.nb-form');this.add=this.querySelector('.nb-add');this.selection=this.querySelector('.nb-selection');this.error=this.querySelector('.nb-error');this.dialog=this.querySelector('dialog');this.viewer=this.querySelector('.nb-main-image');this.caption=this.querySelector('.nb-caption');this.busy=false;
        this.form.addEventListener('change',event=>{const input=event.target;if(input.matches('input[name="design"]')){this.viewer.src=input.dataset.image;this.viewer.removeAttribute('srcset');this.viewer.alt=input.dataset.title;this.caption.textContent=input.dataset.title;}this.update();});
        this.querySelector('.nb-enlarge').addEventListener('click',()=>{this.dialog.querySelector('img').src=this.viewer.currentSrc||this.viewer.src;this.dialog.querySelector('img').alt=this.viewer.alt;this.dialog.querySelector('p').textContent=this.caption.textContent;this.dialog.showModal();});
        this.querySelector('.nb-close').addEventListener('click',()=>this.dialog.close());
        this.dialog.addEventListener('click',event=>{if(event.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)this.dialog.close();}});
        this.form.addEventListener('submit',event=>this.submit(event));
        this.syncCart();
      }
      selected(){return [...this.querySelectorAll('input[name="design"]:checked:not(:disabled)')];}
      update(){const count=this.selected().length;this.selection.textContent=this.dataset.selectedLabel.replace('[count]',String(count));this.add.disabled=count===0||this.busy;}
      async syncCart(){try{const response=await fetch(this.dataset.cartUrl+'.js',{headers:{Accept:'application/json'}});if(!response.ok)return;const cart=await response.json();const ids=new Set(cart.items.map(item=>String(item.variant_id)));this.querySelectorAll('[data-variant-id]').forEach(card=>{if(ids.has(card.dataset.variantId)){const input=card.querySelector('input');input.checked=false;input.disabled=true;card.querySelector('.nb-stock').textContent=this.dataset.cartLabel;}});this.update();}catch(error){this.update();}}
      async submit(event){event.preventDefault();if(this.busy)return;const items=this.selected().map(input=>({id:input.value,quantity:1}));if(!items.length)return;this.busy=true;this.update();this.error.textContent='';try{const response=await fetch(this.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});const data=await response.json();if(!response.ok)throw new Error(data.description||data.message||this.dataset.errorLabel);window.location.assign(this.dataset.cartUrl);}catch(error){this.error.textContent=error.message||this.dataset.errorLabel;this.busy=false;await this.syncCart();this.update();}}
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nail-book"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('nail-book')) {
    customElements.define('nail-book', class extends HTMLElement {
      connectedCallback() {
        if(this.initialized) return;
        this.initialized=true;
        this.form=this.querySelector('.nb-form');this.add=this.querySelector('.nb-add');this.selection=this.querySelector('.nb-selection');this.error=this.querySelector('.nb-error');this.dialog=this.querySelector('dialog');this.viewer=this.querySelector('.nb-main-image');this.caption=this.querySelector('.nb-caption');this.busy=false;
        this.form.addEventListener('change',event=>{const input=event.target;if(input.matches('input[name="design"]')){this.viewer.src=input.dataset.image;this.viewer.removeAttribute('srcset');this.viewer.alt=input.dataset.title;this.caption.textContent=input.dataset.title;}this.update();});
        this.querySelector('.nb-enlarge').addEventListener('click',()=>{this.dialog.querySelector('img').src=this.viewer.currentSrc||this.viewer.src;this.dialog.querySelector('img').alt=this.viewer.alt;this.dialog.querySelector('p').textContent=this.caption.textContent;this.dialog.showModal();});
        this.querySelector('.nb-close').addEventListener('click',()=>this.dialog.close());
        this.dialog.addEventListener('click',event=>{if(event.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)this.dialog.close();}});
        this.form.addEventListener('submit',event=>this.submit(event));
        this.syncCart();
      }
      selected(){return [...this.querySelectorAll('input[name="design"]:checked:not(:disabled)')];}
      update(){const count=this.selected().length;this.selection.textContent=this.dataset.selectedLabel.replace('[count]',String(count));this.add.disabled=count===0||this.busy;}
      async syncCart(){try{const response=await fetch(this.dataset.cartUrl+'.js',{headers:{Accept:'application/json'}});if(!response.ok)return;const cart=await response.json();const ids=new Set(cart.items.map(item=>String(item.variant_id)));this.querySelectorAll('[data-variant-id]').forEach(card=>{if(ids.has(card.dataset.variantId)){const input=card.querySelector('input');input.checked=false;input.disabled=true;card.querySelector('.nb-stock').textContent=this.dataset.cartLabel;}});this.update();}catch(error){this.update();}}
      async submit(event){event.preventDefault();if(this.busy)return;const items=this.selected().map(input=>({id:input.value,quantity:1}));if(!items.length)return;this.busy=true;this.update();this.error.textContent='';try{const response=await fetch(this.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});const data=await response.json();if(!response.ok)throw new Error(data.description||data.message||this.dataset.errorLabel);window.location.assign(this.dataset.cartUrl);}catch(error){this.error.textContent=error.message||this.dataset.errorLabel;this.busy=false;await this.syncCart();this.update();}}
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orchid-pop-showcase"] && !Shopify.designMode) return;
  try {
    
  (()=>{document.querySelectorAll('.op-product').forEach(root=>{const radios=[...root.querySelectorAll('.op-option input')];const select=root.querySelector('.op-variant-select');const price=root.querySelector('[data-price]');const comparePrice=root.querySelector('[data-compare-price]');const saleBadge=root.querySelector('[data-sale-badge]');const button=root.querySelector('.op-add');const label=root.querySelector('[data-add-label]');const update=()=>{const chosen=[...root.querySelectorAll('.op-option input:checked')].map(input=>input.value);const match=[...select.options].find(option=>JSON.stringify(chosen)===option.dataset.options);if(!match)return;select.value=match.value;price.textContent=match.dataset.price;const onSale=match.dataset.onSale==='true';comparePrice.textContent=match.dataset.comparePrice;comparePrice.hidden=!onSale;saleBadge.hidden=!onSale;const available=match.dataset.available==='true';button.disabled=!available;label.textContent=available?'Add to cart':'Sold out'};radios.forEach(radio=>radio.addEventListener('change',update));const dialog=root.querySelector('[data-size-dialog]');root.querySelector('[data-size-open]')?.addEventListener('click',()=>dialog.showModal());root.querySelector('[data-size-close]')?.addEventListener('click',()=>dialog.close());dialog?.addEventListener('click',event=>{if(event.target===dialog)dialog.close()});const imageDialog=root.querySelector('[data-image-dialog]');const zoomImage=root.querySelector('[data-image-zoom]');root.querySelectorAll('[data-zoom-open]').forEach(trigger=>trigger.addEventListener('click',()=>{zoomImage.src=trigger.dataset.zoomSrc;zoomImage.alt=trigger.querySelector('img')?.alt||'';imageDialog.showModal()}));root.querySelector('[data-image-close]')?.addEventListener('click',()=>imageDialog.close());imageDialog?.addEventListener('click',event=>{if(event.target===imageDialog)imageDialog.close()})})})();

  } catch(e) { console.error(e); }
})();
})();
